import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { setUser } from "../../features/user/userSlice";
import { useToast } from "../../hooks/useToast";
import LoadingOverlay from "../../components/loadingOverlay";
import CropModal from "./cropModal";
import { API_BASE } from "../../config/apiConfig";
import { FaUserCircle } from "react-icons/fa";

const AvatarUpload = () => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);
  const { showToast, ToastContainer } = useToast();

  if (!user) return null;

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 700 * 1024;
    if (file.size > maxSize) {
      showToast("File too large. Please upload under 700 KB.", "error");
      return;
    }

    setFile(file);
  };

  const handleCropSave = async (base64) => {
    try {
      setUploading(true);

      const token = sessionStorage.getItem("access_token");

      const res = await fetch(`${API_BASE}/api/update-avatar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ photo: base64 }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.message || "Upload failed");
      }

      const updated = data.updated_user;
      dispatch(setUser(updated));
      sessionStorage.setItem("userDetail", JSON.stringify(updated));

      showToast("Profile picture updated!", "success");
    } catch (err) {
      console.error("Avatar upload failed:", err);
      showToast("Error updating avatar", "error");
    } finally {
      setUploading(false);
      setFile(null);
    }
  };

  return (
    <div className="relative group w-24 h-24">
      {/* Avatar OR default icon */}
      {user.photo ? (
        <img
          src={user.photo}
          alt="Avatar"
          className="w-24 h-24 rounded-full border object-cover"
        />
      ) : (
        <FaUserCircle className="w-24 h-24 text-gray-400" />
      )}

      {/* Hover overlay */}
      <label
        htmlFor="avatar-upload"
        className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center
                   text-white text-sm rounded-full opacity-0 group-hover:opacity-100
                   transition cursor-pointer"
      >
        {uploading ? "Uploading..." : "Change"}
      </label>

      <input
        id="avatar-upload"
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleFileUpload}
        disabled={uploading}
      />

      {file && (
        <CropModal
          file={file}
          onCancel={() => setFile(null)}
          onSave={handleCropSave}
        />
      )}

      <LoadingOverlay show={uploading} text="Uploading..." />
      <ToastContainer />
    </div>
  );
};

export default AvatarUpload;
